import React, {useState, useEffect} from 'react';
import { styled } from "@mui/material/styles";
import {Card, Grid, CardMedia, Button, CardActions, CardActionArea, Typography, Grow } from '@mui/material';
import Iframe from '../Iframe/Iframe';


const EpisodeCard = ({item, serieId, handleIframe}) =>{
    const EpisodeMarker = styled("div")(({ theme }) => ({
        color: "#fff",
        position: "absolute",
        top: "-5px",
        right: "-4px",
        background: "#111",
        height: "2.2rem",
        width: "2.2rem",
        textAlign: "center",
        lineHeight: "2.2rem",
        borderRadius: "50%",
      }));
      const EpisodeName = styled("div")(({ theme }) => ({
        color: "#ededed",
        fontSize:"0.8rem",
        bottom: "0px",
        width:"100%",
        background: "#1111113b",
        lineHeight:"1.5rem",
        position:"absolute",
        textAlign: "center",
       
      }));
   
      return(
        <>
        <Grid item  className='custom-card' onClick={()=>handleIframe({show:true,type:'tv',serieId:serieId,seasonNumber:item.season_number, episodeNumber:item.episode_number})}>
        <Grow in>
        <Card sx={{ maxWidth: 350, borderRadius:"18px", backgroundColor:"#fff0" }}>
        <CardActionArea sx={{height:'15rem',borderRardius:"15px",backgroundColor:"#2d2d2d",backgroundImage:`url(https://image.tmdb.org/t/p/w300/${item.still_path})`, backgroundSize:"cover", backgroundPosition:"center"}}>
          <EpisodeMarker>{item.episode_number<10?'0':''}{item.episode_number}</EpisodeMarker>
          <EpisodeName>{item.name}</EpisodeName>
          </CardActionArea>
        </Card>
        </Grow>
        </Grid>
    
        </>
      );
  }
  export default EpisodeCard;